module.exports = __webpack_public_path__ + "img/cross2green.842af2a6.png";